export default __webpack_public_path__ + "static/media/usdc.93c65b88.png";